function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import CheckCircleIcon from '@heroicons/react/20/solid/CheckCircleIcon';
import { isEmpty, last } from 'lodash';
import { Translate } from "../../../../../I18N";
import { InputField, Select } from "../../../../Components/Forms";
import { Button, Card, Sidepanel } from "../../../../Components/UI";
import uniqueID from "../../../../../../shared/uniqueID";










const emptyRow = () => ({ label: '', rowId: uniqueID() });

const ThesauriValueFormSidepanel = ({
  submit,
  closePanel,
  thesaurusValues,
  value,
  showSidepanel
}) => {
  const editMode = value.length === 1;
  const groups = (thesaurusValues || []).filter((item) => item.subRows !== undefined);
  const { reset, control, register, handleSubmit, watch } = useForm(

    {
      mode: 'onSubmit',
      defaultValues: { newValues: value.length ? value : [emptyRow()] }
    });

  useEffect(() => {
    reset({ newValues: value.length ? value : [emptyRow()] });
  }, [reset, value]);

  const { append, fields } = useFieldArray({ control, name: 'newValues', keyName: 'rowId' });

  useEffect(() => {
    const subscription = watch((formData) => {var _last;
      const values = formData.newValues;
      if (!editMode && !isEmpty((_last = last(values)) === null || _last === void 0 ? void 0 : _last.label)) {
        append(emptyRow(), { shouldFocus: false });
      }
    });
    return () => subscription.unsubscribe();
  }, [editMode, watch, append, value]);

  const submitHandler = (data) => {
    submit(data.newValues.filter((thesaurus) => thesaurus.label !== ''));
    closePanel();
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: closePanel,
      title: editMode ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit item") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add item") }, void 0, /*#__PURE__*/

    _jsx("form", {
      onSubmit: handleSubmit(submitHandler),
      className: "flex flex-col h-full",
      id: "value-thesauri-form",
      "data-testid": "value-thesauri-form" }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, {}, void 0,
    value.length === 0 && /*#__PURE__*/
    _jsx("div", { className: "p-4 mb-4 border rounded-md shadow-sm border-gray-50 bg-primary-100 text-primary-700" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-1 text-base font-semibold" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-5 h-5 text-sm" }, void 0, /*#__PURE__*/
    _jsx(CheckCircleIcon, {})
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Adding items to the thesauri")
    ), /*#__PURE__*/
    _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "You can add one or many items in this form."), /*#__PURE__*/
    _jsx("br", {}), /*#__PURE__*/
    _jsx(Translate, { translationKey: "thesauri new item desc" }, void 0, "Once you type the first item name, a new item form will appear underneath it, so you can keep on adding as many as you want."


    )
    )
    ),

    fields.map((localValue, index) => /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Item") }, localValue.rowId, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "item-name",
      "data-testid": "thesauri-form-item-name",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Title") },
    register(`newValues.${index}.label`))
    ),
    groups && /*#__PURE__*/
    React.createElement(Select, _extends({
      id: "item-group",
      "data-testid": "thesauri-form-item-group",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Group") },
    register(`newValues.${index}.groupId`), {
      disabled: value.length > 0,
      options: [
      { value: '', label: 'No Group', key: '0' },
      ...groups.map((group) => ({
        value: group.rowId,
        label: group.label,
        key: group.rowId
      }))] })

    )

    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "bottom-0 px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: closePanel,
      className: "grow",
      "data-testid": "thesaurus-form-cancel" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", type: "submit", "data-testid": "thesaurus-form-submit" }, void 0,
    !editMode && /*#__PURE__*/_jsx(Translate, {}, void 0, "Add"),
    editMode && /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit")
    )
    )
    )
    )
    ));

};

export { ThesauriValueFormSidepanel };